import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { configureActions } from '../../../../../actions/configure.action';
import { generalActions } from '../../../../../actions/general.action';
import helper from '../../../../../utils/helper';
import NewDepartmentPage from './NewDepartmentPage';

class NewDepartment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      errors: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    state.errors = helper.centralizeError([nextProps.configure.errors]);
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    return Object.keys(state).length ? state : null;
  }

  componentDidMount() {
    this.props.generalActions.clearError();
  }

  onCreateDepartment = (params) => {
    this.setState({ isSubmitting: true }, async () =>
      this.props.configureActions
        .createDepartment(params)
        .then(() => this.props.history.push('/configure/departments'))
        .catch(() => this.setState({ isSubmitting: false })),
    );
  };
  render() {
    return (
      <NewDepartmentPage
        {...this.state}
        onCreateDepartment={this.onCreateDepartment}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(NewDepartment);
